import { useState } from 'react'
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import { commonMessages } from 'app/i18n/messages'
import ConfirmModal from 'components/Modal/ConfirmModal'
import SuccessModal from 'components/Modal/SuccessModal'

import { SubsCancelFormContent } from './styles'
import { cancelSubscriptionMessages } from './messages'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { purchaseSubscriptionThunk } from 'features/home/components/HomeSubscription/SubscriptionManagement/UpgradeSubscription/slice'
import { fetchSubscriptionHistoryThunk } from 'features/home/components/HomeSubscription/SubscriptionHistory/slice'

interface CancelNetworkModalProps {
  homeId: string
  onClose: () => void
  periodEnd: any
  priceId: string
  paymentMethodId: string
}

const CancelNetworkModal = ({
  homeId,
  onClose,
  periodEnd,
  priceId,
  paymentMethodId,
}: CancelNetworkModalProps) => {
  const { formatMessage } = useIntl()
  const dispatch = useAppDispatch()
  const rootDomainId = useAppSelector(currentRootDomainIdSelector)

  const [error, setError] = useState<null | string>(null)
  const [isLoading, setLoading] = useState(false)

  const onSubmit = async () => {
    setLoading(true)
    try {
      rootDomainId &&
        (await dispatch(
          purchaseSubscriptionThunk({
            paymentMethodId,
            homeId,
            rootDomainId,
            type: 'company',
            couponId: '',
            items: [
              {
                priceId,
                quantity: 0,
              },
            ],
          })
        ))
      onClose()
    } catch (err: any) {
      setError(formatMessage(commonMessages.commonError))
    } finally {
      rootDomainId &&
        (await dispatch(fetchSubscriptionHistoryThunk(rootDomainId, homeId)))
      setLoading(false)
    }
  }

  if (error) {
    return (
      <SuccessModal
        isOpen={!!error}
        title={formatMessage(commonMessages.error)}
        confirmBtnTitle={formatMessage(commonMessages.close)}
        onConfirm={() => setError(null)}
      >
        {error}
      </SuccessModal>
    )
  }

  return (
    <ConfirmModal
      isOpen={!error}
      onDiscard={onClose}
      title={<FormattedMessage {...cancelSubscriptionMessages.titleNetwork} />}
      discardBtnTitle={
        <FormattedMessage {...cancelSubscriptionMessages.cancelBtn} />
      }
      confirmBtnTitle={
        <FormattedMessage {...cancelSubscriptionMessages.ctaBtn} />
      }
      onConfirm={onSubmit}
      variant="primary"
      isConfirmBtnDisabled={isLoading}
    >
      <SubsCancelFormContent>
        <FormattedMessage
          {...cancelSubscriptionMessages.confirmTextNetwork}
          values={{
            planName: formatMessage(commonMessages.networkPlan),
            planEndDate: <FormattedDate value={periodEnd} />,
            br: <br />,
            b: (...chunks: any) => <b>{chunks}</b>,
          }}
        />
      </SubsCancelFormContent>
    </ConfirmModal>
  )
}

export default CancelNetworkModal
